import { useEffect, useState } from "react";
import { isUserInOsloTimeZone } from "../Helpers/timeZoneHelpers";
import {
  FormDispatch,
  FormFields,
  FormReducer,
  FormStateType,
} from "../Helpers/formTypes";

export const useTimeZoneModal = (
  state: FormStateType,
  dispatch: FormDispatch,
  areAppointmentsLoaded: boolean,
  appointmentsLoadingHasError: boolean
) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    if (
      isUserInOsloTimeZone() ||
      state.wasDifferentTimeZoneModalShown ||
      !areAppointmentsLoaded ||
      appointmentsLoadingHasError
    )
      return;

    setShowModal(true);
    dispatch({
      type: FormReducer.update,
      field: FormFields.wasDifferentTimeZoneModalShown,
      payload: true,
    });
  }, [areAppointmentsLoaded, appointmentsLoadingHasError]);

  return {
    showTimeZoneModal: showModal,
    setShowTimezoneModal: setShowModal,
  };
};
